"use client";

import { useState } from "react";
import * as yup from "yup";

interface IErrors {
  [key: string]: string;
}

const useValidation = (validationSchema: yup.ObjectSchema<any>) => {
  const [errors, setErrors] = useState<IErrors>({});

  const validateField = async (field: string, value: string) => {
    try {
      await validationSchema.validateAt(field, { [field]: value });
      setErrors({
        ...errors,
        [field]: "",
      });
    } catch (err) {
      if (err instanceof Error) {
        setErrors({
          ...errors,
          [field]: err.message,
        });
      }
    }
  };

  const validateForm = async (form: { [key: string]: string }) => {
    const validationErrors: IErrors = {};
    let isValid = true;

    for (const key in form) {
      try {
        await validationSchema.validateAt(key, { [key]: form[key] });
      } catch (err) {
        if (err instanceof Error) {
          validationErrors[key] = err.message;
          isValid = false;
        }
      }
    }
    setErrors(validationErrors);
    return isValid;
  };

  return { errors, validateField, validateForm };
};

export default useValidation;
